export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3 md:gap-4">
    <span className={`shrink-0 ${light ? "rounded-xl bg-[var(--bone)] p-2" : ""}`}>
      <img src="/images/flair-stack.png" alt="Flair" className="h-12 md:h-14 w-auto" />
    </span>
    <span className={`h-9 md:h-10 w-px ${light ? "bg-white/25" : "bg-[var(--line)]"}`} />
    <span className={`font-display text-lg md:text-[22px] font-medium tracking-tight leading-tight whitespace-nowrap ${light ? "text-[var(--bone)]" : "text-[var(--forest)]"}`}>
      Gait Naurish Ltd.
    </span>
  </span>
);
